import { GridSortItem } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import CustomDataGridV2 from "../../../../../components/CustomDataGridV2";
import Text from "../../../../../components/Text";
import ToggleSwitch from "../../../../../components/ToggleSwitch";
import ActionMenu from "../../../../../components/app/ActionMenu";
import LoincCodeCatalogDrawer from "../../../../../components/app/admin/Library/catalog/LoincCodeCatalogDrawer";
import { useRoleController } from "../../../../../components/useRoleController";
import { hcpcsCodeCatalogInitialValuesType } from "../../../../../constants/initial-schemas";
import useDisclosure from "../../../../../hooks/use-disclosure";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import { useArchiveCatalogCode } from "../../../../../queries/catalog/use-archive-catalog-code";
import useGetCataLogCode from "../../../../../queries/catalog/use-get-catalog-code";
import { useStatusUpdateCatalogCode } from "../../../../../queries/catalog/use-status-update-catalog-code";
import {
  DGT_Pagination,
  SMALL_PAGE_SIZE,
  applyDefaultColumnSettings,
  filterActionCol,
  getSuccessSnackbar,
  isAdmin,
} from "../../../../../utils/utils";
// import { GlobalTableHeightWrapper } from "../../../../../components/GlobalTableHeightWrapper";
import PageLayout from "../../../../../components/PageLayout";

const CatalogLOINCCodeCatalog = () => {
  const { search: searchKey, isArchieved: archived }: any = useOutletContext();
  const { hasUpdate: hasMasterData } = useRoleController(
    "Master Data > CPT Codes"
  );
  const [pagination, setPagination] = useState<DGT_Pagination>({
    page: 0,
    pageSize: SMALL_PAGE_SIZE,
  });
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const {
    data,
    refetch,
    isLoading: isTableLoading,
    isFetching,
  } = useGetCataLogCode({
    gridSorting,
    pagination,
    searchKey,
    type: "LOINC",
    active: undefined,
    archive: archived,
  });
  const showSnackbar = useSnackbar();

  const { mutateAsync: updateStatus } = useStatusUpdateCatalogCode();
  const { mutateAsync: deleteLoincCode } = useArchiveCatalogCode();

  const [editLoincCodeValues, setEditLoincCodeValues] =
    useState<hcpcsCodeCatalogInitialValuesType>();
  const [uuid, setUuid] = useState<string>();

  const loincEditDisclosure = useDisclosure(false);

  const GiveList = (archiveFlag: boolean) => {
    return useMemo(() => {
      return archiveFlag
        ? [{ value: "unarchive", label: "Unarchive" }]
        : [
            { value: "edit", label: "Edit" },
            { value: "delete", label: "Archive" },
          ];
    }, [archiveFlag]); // Recomputes only when 'archiveFlag' changes
  };

  const COLUMNS = applyDefaultColumnSettings<any>([
    {
      field: "code",
      flex: 0.5,
      minWidth: 180,
      // headerName: "LOINC Code",
      renderHeader: () => (
        <Text isTabletext ml={"20px"}>
          LOINC Code
        </Text>
      ),
      sortable: false,
      renderCell: ({ value }) => (
        <Text isTabletext ml={"20px"}>
          {value}
        </Text>
      ),
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      minWidth: 500,
      sortable: false,
    },
    {
      field: "active",
      headerName: "Status",
      width: 150,
      sortable: false,
      renderCell: ({ row, value }) => (
        <ToggleSwitch
          id={row.uuid?.toString()}
          checked={value}
          onConfirm={(status, id) =>
            updateStatus({ medicalCodeId: id as string, status }).then(
              (res) => {
                refetch();
                return res;
              }
            )
          }
        />
      ),
    },
    {
      field: "Action",
      width: 90,
      hideSortIcons: true,
      renderCell: ({ row }) => {
        return (
          <ActionMenu
            options={GiveList(row?.archive)}
            onActionClick={(v) => {
              if (v === "edit") {
                setUuid(row.uuid?.toString());
                const transformedValues = {
                  loinc_code: row?.code,
                  description: row?.description,
                };
                setEditLoincCodeValues(transformedValues as any);
                loincEditDisclosure.open();
              } else {
                deleteLoincCode({
                  medicalCodeId: row?.uuid?.toString() as string,
                  archive: v === "delete",
                }).then((res) => {
                  refetch();
                  showSnackbar(getSuccessSnackbar(res));
                  return res;
                });
              }
            }}
          />
        );
      },
    },
  ]);

  return (
    <PageLayout>
      <LoincCodeCatalogDrawer
        dialogTitle="Edit LOINC Code"
        initialValues={editLoincCodeValues as any}
        disclosureHost={loincEditDisclosure}
        uuid={uuid}
      />
      {/* <DeleteModal
        w="380px"
        open={openedDeleteModal}
        onClose={closeDeleteModal}
        id={deleteId}
        onConfirmation={(id) =>
          deleteLoincCode({ medicalCodeId: id as string }).then((res) => {
            refetch();
            return res;
          })
        }
        content={"you want to delete this LOINC Code"}
      /> */}

      <CustomDataGridV2
        loading={isTableLoading || isFetching}
        searchString={searchKey}
        rows={data?.data?.content ?? []}
        getRowId={(row) => row?.uuid}
        columns={filterActionCol(COLUMNS, !isAdmin() ? !hasMasterData : false)}
        disableRowSelectionOnClick
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        onSortModelChange={setGridSorting}
        rowCount={data?.data?.page?.totalElements ?? 10}
      />
    </PageLayout>
  );
};

export default CatalogLOINCCodeCatalog;
